import React, { useEffect, useState } from "react";
import { Form, Row, Col, Modal } from "react-bootstrap";

const Urlmodals = (props) => {
  console.log('props?.data-->',props?.data.records.fields?.["Summary Details"]?.type)
  return (
    <>
      <Modal
        show={props.urlmod}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        contentLabel="Example Modal"
      >
        <Modal.Header closeButton onClick={props.onDismiss}>
          <Modal.Title id="contained-modal-title-vcenter">URL</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col xs={12} sm={12} md={6} lg={6} className="mb-4">
              <Form.Group>
                <Form.Label>Base Url</Form.Label>
                <Form.Control
                  type="text"
                  name="baseurl"
                  placeholder="Eg:https://api.binance.com/"
                  onChange={(e) => props.onChangeFunc(e)}
                />
              </Form.Group>
            </Col>
            {props?.data.records.fields?.["Summary Details"]?.type == "spot" ? (
              <>
                <Col xs={12} sm={12} md={6} lg={6} className="mb-4">
                  <Form.Group>
                    <Form.Label>Ticker Url</Form.Label>
                    <Form.Control
                      type="text"
                      name="tickerurl"
                      placeholder="Eg:api/v1/ticker/24hr"
                      onChange={(e) => props.onChangeFunc(e)}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} sm={12} md={6} lg={6} className="mb-4">
                  <Form.Group>
                    <Form.Label>OrderBook Url</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Eg:api/v1/depth?symbol="
                      name="orderbookurl"
                      onChange={(e) => props.onChangeFunc(e)}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} sm={12} md={6} lg={6} className="mb-4">
                  <Form.Group>
                    <Form.Label>Historical Url</Form.Label>
                    <Form.Control
                      type="text"
                      name="historicalurl"
                      onChange={(e) => props.onChangeFunc(e)}
                    />
                  </Form.Group>
                </Col>
                {/* <Col xs={12} sm={12} md={6} lg={6} className="mb-4">
                  <Form.Group>
                    <Form.Label>Pair Url</Form.Label>
                    <Form.Control
                      type="text"
                      name="pairurl"
                      onChange={(e) => props.onChangeFunc(e)}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} sm={12} md={6} lg={6} className="mb-4">
                  <Form.Group>
                    <Form.Label>Historical Url</Form.Label>
                    <Form.Control
                      type="text"
                      name="historicalurl"
                      onChange={(e) => props.onChangeFunc(e)}
                    />
                  </Form.Group>
                </Col> */}
              </>
            ) : (
              <>
                <Col xs={12} sm={12} md={6} lg={6} className="mb-4">
                  <Form.Group>
                    <Form.Label>Contract Url</Form.Label>
                    <Form.Control
                      type="text"
                      name="contracturl"
                      onChange={(e) => props.onChangeFunc(e)}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} sm={12} md={6} lg={6} className="mb-4">
                  <Form.Group>
                    <Form.Label>OrderBook Url</Form.Label>
                    <Form.Control
                      type="text"
                      name="orderbookurl"
                      onChange={(e) => props.onChangeFunc(e)}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} sm={12} md={6} lg={6} className="mb-4">
                  <Form.Group>
                    <Form.Label>Historical Url</Form.Label>
                    <Form.Control
                      type="text"
                      name="historicalurl"
                      onChange={(e) => props.onChangeFunc(e)}
                    />
                  </Form.Group>
                </Col>
              </>
            )}
          </Row>
          <div className="text-center">
            <button
              type="button"
              onClick={() => props.onSummitFunc("approved")}
              className="btn sitebtn py-2 px-3 mt-3 mb-3 mx-2"
            >
              Submit
            </button>
          </div>
          <div></div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Urlmodals;
